import { isProfileComplete } from '@echo/core';
import { useMe, useSession } from '@echo/core/react';
import { createFileRoute, Navigate, useNavigate } from '@tanstack/react-router';
import { BrianHello } from '@/components/brian-hello';
import { markWelcomeSeen, useWelcomeSeen } from '@/lib/welcome-store';

export const Route = createFileRoute('/welcome')({ component: WelcomePage });

/**
 * The welcome once per sign-in: the app layout sends signed-in people
 * here until "Continue to home" marks it seen, and About is a step away so they can read
 * it before going on. Anyone who is not signed in, or has no profile yet, goes where those
 * are handled first.
 */
function WelcomePage() {
  const session = useSession();
  const me = useMe();
  const navigate = useNavigate();
  const seen = useWelcomeSeen();
  if (session.status === 'unknown' || (session.status === 'authenticated' && !me.isFetched)) {
    return null;
  }
  if (session.status !== 'authenticated') return <Navigate to="/sign-in" replace />;
  if (me.data && !isProfileComplete(me.data)) return <Navigate to="/onboarding" replace />;
  if (seen) return <Navigate to="/" replace />;
  return <BrianHello onContinue={markWelcomeSeen} onAbout={() => navigate({ to: '/about' })} />;
}
